import './bootstrap';
import.meta.glob([
    '../images/**',
    '../fonts/**',]);
import { lenis } from './lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import intersect from '@alpinejs/intersect'
import swipePlugin from "alpinejs-swipe";
import * as ThumbmarkJS from '@thumbmarkjs/thumbmarkjs';
import '../../vendor/masmerise/livewire-toaster/resources/js';
import { mobile } from './helpers/helpers';
import { SplitText } from 'gsap/SplitText';
import initVideoOptimization from './videoManager';

document.addEventListener('livewire:init', () => {
    Livewire.on('make-fingerprint', async (event) => {
        ThumbmarkJS.setOption('include', ['webgl', 'system.browser.version', 'canvas', 'locales.languages'])
        await ThumbmarkJS.getFingerprint().then(
            function (fingerprint) {
                window.Livewire.dispatch('fingerprint-generated', { payload: fingerprint });
            }
        );
    });
});

Alpine.plugin(intersect)
Alpine.plugin(swipePlugin);
gsap.registerPlugin(ScrollTrigger);


window.stopScroll = function () {
    if (mobile) {
        document.body.style.overflow = 'hidden';
    } else {
        lenis.stop();
    }
};

window.startScroll = function () {
    if (window.location.pathname !== '/shorts' || window.location.pathname !== '/messenger') {
        if (mobile) {
            document.body.style.overflow = 'auto';
        } else {
            lenis.start();
        }
    }
};

document.addEventListener('livewire:navigate', (event) => {
    lenis.start();
});

document.addEventListener('livewire:navigated', (event) => {
    Alpine.initTree(document.body)
});

if (mobile) {
    if (window.location.pathname === '/shorts') {
        $('footer').addClass('hidden')
        $('#main-nav').addClass('hidden')
        $('#background').addClass('hidden')
    }
}

$(document).on('click', '.share-btn', async function () {
    const url = $(this).data('url');

    if (!navigator.share) {
        console.warn("Web Share API not supported.");
        return;
    }

    try {
        await navigator.share({
            title: "Watchimo",
            url: url
        });
    } catch (err) {
        console.error("Share failed:", err.message);
    }
});


$(document).ready(function () {
    // Check if the current route path is '/new-content'
    if (window.location.pathname === '/new-content') {
        // Check if screen width is mobile
        if ($(window).width() <= 768) {
            $('footer').hide();
        }
    }
});


if (window.location.pathname === '/' || window.location.pathname === '/b') {
    gsap.registerPlugin(SplitText);
    gsap.registerPlugin(Observer);



    let isMobile = false;
    let isBellow1024 = false;
    let viewportWidth = 0;
    let isIOS = false;
    let isAndroid = false;

    function updateViewportStatus() {
        viewportWidth = window.innerWidth;
        const wasMobile = isMobile;
        isMobile = viewportWidth < 768;
        isBellow1024 = viewportWidth < 1024;

        // Detect iOS and Android
        const ua = navigator.userAgent || '';
        isIOS = /iPhone|iPad|iPod/i.test(ua);
        isAndroid = /Android/i.test(ua);

        return wasMobile !== isMobile;
    }

    function isSafariBrowser() {
        if (typeof navigator === 'undefined') return false;

        const ua = navigator.userAgent || '';
        const vendor = navigator.vendor || '';
        const isAppleVendor = /apple/i.test(vendor);
        const isSafariUA = /safari/i.test(ua);
        const isExcludedEngine =
            /(chrome|crios|crmo|fxios|firefox|edg|edgios|edga|opr|opera|ucbrowser|samsungbrowser)/i.test(
                ua
            );

        return (
            isSafariUA &&
            !isExcludedEngine &&
            (isAppleVendor || /mac|iphone|ipad|ipod/i.test(ua))
        );
    }

    function applySafariTextOffset() {
        if (!isSafariBrowser()) return;

        const safariText = document.getElementById('safari-text');
        if (!safariText) return;

        const computedStyles = window.getComputedStyle(safariText);
        const currentMarginBottom = parseFloat(computedStyles.marginBottom) || 0;

        safariText.style.marginBottom = `${currentMarginBottom + 50}px`;
    }

    updateViewportStatus();

    document.addEventListener('DOMContentLoaded', () => {
        updateViewportStatus();
        applySafariTextOffset();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const mobileChanged = updateViewportStatus();
            if (mobileChanged) {
                ScrollTrigger.refresh();

                animateSimplicityTitle();
                animateTags();

                if (!isMobile) {
                    initVideoPreview();
                    animateStripeIphone();
                }
            }
        }, 250);
    });

    function animatePreloader(lenis, onCallbackFunction) {
        const preloaderSection = document.getElementById('initial-animation');
        const textContainer = document.getElementById('text-container');
        const svg = document.getElementById('preloader-svg');
        const preloaderContainer = document.getElementById('preloader-container');
        const heroElements = document.querySelectorAll('.hero-element');
        const heroSvgContainer = document.querySelector('.hero-svg-container');

        textContainer.innerHTML = '';
        const words = ['Watch', 'it', 'more'];
        const allChars = [];

        words.forEach((word, wordIndex) => {
            word.split('').forEach((char) => {
                const charSpan = document.createElement('span');
                charSpan.textContent = char;
                charSpan.style.display = 'inline-block';
                allChars.push(charSpan);
                textContainer.appendChild(charSpan);
            });
            if (wordIndex < words.length - 1) {
                const spaceSpan = document.createElement('span');
                spaceSpan.innerHTML = '&nbsp;';
                spaceSpan.style.display = 'inline-block';
                allChars.push(spaceSpan);
                textContainer.appendChild(spaceSpan);
            }
        });

        const chars = allChars;

        const initialIndices = [0, 1, 2, 3, 4, 6, 9];
        const expandingIndices = [5, 7, 8, 10, 11, 12];

        const initialChars = initialIndices
            .map((i) => chars[i])
            .filter((char) => char);
        const expandingChars = expandingIndices
            .map((i) => chars[i])
            .filter((char) => char);

        chars.forEach((charElement) => {
            gsap.set(charElement, {
                display: 'inline-block',
                verticalAlign: 'bottom',
                margin: 0,
                padding: 0,
            });
        });

        const masterTl = gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    if (preloaderSection) {
                        preloaderSection.style.display = 'none';
                    }

                    onCallbackFunction();

                    window.scrollTo(0, 0);
                    if (lenis) {
                        lenis.scrollTo(0, { immediate: true, force: true });
                        lenis.start();
                    }

                    document.body.style.overflow = '';
                    document.documentElement.style.overflow = '';
                    document.body.classList.remove('preloader-active');
                    document.documentElement.classList.remove('preloader-active');
                }, 100);
            },
            defaults: {
                ease: 'power4.out',
            },
        });

        gsap.set(preloaderSection, {
            opacity: 1,
            visibility: 'visible',
            display: 'block',
        });

        gsap.set(textContainer, {
            opacity: 0,
            overflow: 'hidden',
            width: 0,
            visibility: 'hidden',
            transformOrigin: 'left center',
        });

        gsap.set(svg, {
            opacity: 0,
            scale: 0.5,
            width: isMobile ? '8vw' : '6vw',
            height: isMobile ? '8vw' : '6vw',
            x: 0,
            display: 'block',
            visibility: 'visible',
        });

        gsap.set(preloaderContainer, {
            gap: isMobile ? 2 : 8,
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'nowrap',
            xPercent: -50,
            yPercent: -30,
            left: '50%',
            top: isMobile ? '35%' : '45%',
            position: 'absolute',
        });

        gsap.set(chars, {
            opacity: 0,
            visibility: 'hidden',
        });

        gsap.set(chars, {
            opacity: 0,
            y: 50,
            rotationX: -90,
            visibility: 'visible',
        });

        gsap.set(expandingChars, {
            width: 0,
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
        });

        gsap.set(initialChars, {
            opacity: 0,
        });

        masterTl.to(svg, {
            opacity: 1,
            scale: 1,
            duration: 0.4,
            y: '0.5vw',
            ease: 'power4.in',
        });

        masterTl.to(
            textContainer,
            {
                visibility: 'visible',
                duration: 0,
            },
            '+=0.04'
        );

        masterTl.to(
            textContainer,
            {
                width: 'auto',
                opacity: 1,
                duration: 0.5,
                ease: 'power2.inOut',
            },
            '-=0.1'
        );

        masterTl.to(
            initialChars,
            {
                opacity: 1,
                y: 0,
                rotationX: 0,
                duration: 0.5,
                ease: 'back.out(1.7)',
                stagger: 0.04,
            },
            '-=0.3'
        );

        masterTl.to(
            preloaderContainer,
            {
                gap: isMobile ? 12 : 42,
                duration: 0.4,
                ease: 'power2.inOut',
                onUpdate: function () {
                    const containerWidth = preloaderContainer.offsetWidth;
                    gsap.set(preloaderContainer, {
                        xPercent: -50,
                    });
                },
            },
            '-=0.4'
        );
        masterTl.to(
            svg,
            {
                width: '8vw',
                height: '8vw',
                duration: 0.6,
                ease: 'power2.inOut',
            },
            '<'
        );

        masterTl.to(
            expandingChars,
            {
                width: 'auto',
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: 0,
                paddingRight: 0,
                duration: 0.5,
                stagger: 0.05,
                ease: 'power2.inOut',
            },
            '<0.1'
        );

        masterTl.to(
            expandingChars,
            {
                opacity: 1,
                y: 0,
                rotationX: 0,
                duration: 0.5,
                stagger: 0.05,
                ease: 'back.out(1.7)',
            },
            '<0.04'
        );

        masterTl.to(
            chars,
            {
                opacity: 0,
                scale: 0.5,
                x: 16,
                rotationX: 60,
                duration: 0.4,
                ease: 'power2.in',
                stagger: {
                    amount: 0.1,
                    from: 'end',
                },
            },
            '>'
        );

        masterTl.to(
            textContainer,
            {
                width: 0,
                padding: 0,
                margin: 0,
                duration: 0.4,
                ease: 'power2.inOut',
            },
            '>-0.3'
        );

        masterTl.to(
            preloaderContainer,
            {
                gap: 8,
                justifyContent: 'center',
                duration: 0.4,
                ease: 'power2.inOut',
            },
            '<'
        );

        masterTl.to(
            svg,
            {
                x: 0,
                duration: 0.4,
                ease: 'power2.inOut',
                onStart: () => {
                    if (lenis) {
                        lenis.scrollTo(0, { immediate: true, force: true });
                    }
                },
            },
            '<'
        );

        const descriptionTimeline = animateHeroDescription();

        masterTl.set(heroElements, {
            opacity: 0,
            y: 50,
        });

        masterTl.set(heroSvgContainer, {
            opacity: 0,
        });

        masterTl.to(
            preloaderSection,
            {
                opacity: 0,
                duration: 0.5,
                ease: 'power2.inOut',
            },
            '+=0.1'
        );

        masterTl.to(
            svg,
            {
                scale: 0,
                opacity: 0,
                duration: 0.3,
                ease: 'power2.inOut',
            },
            '-=0.8'
        );

        const heroButton = document.querySelector('#hero-button');
        masterTl.to(
            [
                heroElements[0],
                heroSvgContainer,
                heroElements[1],
                heroElements[2],
                heroElements[3],
                heroElements[4],
            ],
            {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power4.inOut',
                stagger: 0.2,
                onStart: () => {
                    if (descriptionTimeline) {
                        descriptionTimeline.play();
                        console.log('Playing description timeline');
                    }
                },
                onComplete: () => {
                    heroButton.classList.add('transition-all');
                },
            },
            '<'
        );

        return masterTl;
    }

    function animateHeroTitle() {
        const textElements = [
            document.getElementById('text-word1'),
            document.getElementById('text-word2'),
            document.getElementById('text-word3'),
            document.getElementById('text-word4'),
        ];

        const mobileTextElements = [
            document.getElementById('text-word1-mobile'),
            document.getElementById('text-word2-mobile'),
            document.getElementById('text-word3-mobile'),
            document.getElementById('text-word4-mobile'),
        ];

        const allTextElements = [...textElements, ...mobileTextElements];

        const delayBetween = 0.7;
        const moveDuration = 0.5;
        const moveY = -200;
        const ease = 'power3.inOut';

        const overlapFactor = 0.9;
        const overlapDuration = moveDuration * overlapFactor;

        gsap.set(allTextElements, {
            opacity: 0,
            visibility: 'hidden',
        });

        gsap.set([textElements[0], mobileTextElements[0]], {
            y: -moveY,
            opacity: 0,
            visibility: 'visible',
        });

        // Animate the first word in from below on initial load (one-shot, not part of loop)
        gsap.to([textElements[0], mobileTextElements[0]], {
            y: 0,
            opacity: 1,
            duration: moveDuration,
            ease: ease,
        });

        const tl = gsap.timeline({ repeat: -1 });

        textElements.forEach((element, index) => {
            const nextElement = textElements[(index + 1) % textElements.length];
            const mobileElement = mobileTextElements[index];
            const nextMobileElement =
                mobileTextElements[(index + 1) % mobileTextElements.length];

            tl.to([element, mobileElement], {
                delay: delayBetween,
                y: moveY,
                opacity: 0,
                duration: moveDuration,
                ease: ease,
            });

            tl.set(
                [nextElement, nextMobileElement],
                {
                    y: -moveY,
                    opacity: 0,
                    visibility: 'visible',
                },
                '>-' + overlapDuration
            ).to(
                [nextElement, nextMobileElement],
                {
                    y: 0,
                    opacity: 1,
                    duration: moveDuration,
                    ease: ease,
                },
                '<'
            );
        });

        return tl;
    }

    function animateHeroDescription() {
        const description = document.getElementById('hero-description');
        if (!description) return null;

        console.log('Animating hero description');

        const splitText = new SplitText(description, {
            type: 'lines',
            linesClass: 'split-line',
        });

        const lines = splitText.lines;

        lines.forEach((line, index) => {
            const isEven = index % 2 === 0;
            gsap.set(line, {
                x: isEven ? '-50%' : '50%',
                opacity: 0,
            });
        });

        const tl = gsap.timeline({
            paused: true,
        });

        tl.to(lines, {
            delay: 0.6,
            opacity: 1,
            stagger: 0.05,
            x: 0,
            duration: 1.0,
            ease: 'power4.inOut',
        });

        return tl;
    }

    function animateButtonRings(buttonSelector, options = {}) {
        const button = document.querySelector(buttonSelector);
        if (!button) return;

        const rings = Array.from(button.querySelectorAll('[id^="ring-"]'));
        if (!rings.length) return;

        let timelines = [];

        const config = {
            initialScale: options.initialScale || 0.9,
            maxScale: options.maxScale || 2.5,
            duration: options.duration || 10,
            fadeInDuration: options.fadeInDuration || 1,
            stagger: options.stagger || 0.25,
        };

        function setupRings() {
            timelines.forEach((tl) => tl.kill());
            timelines = [];

            const buttonRect = button.getBoundingClientRect();
            const buttonWidth = buttonRect.width;
            const buttonHeight = buttonRect.height;

            const initialWidth = buttonWidth * config.initialScale;
            const initialHeight = buttonHeight * config.initialScale;
            const maxWidth = buttonWidth * config.maxScale;
            const maxHeight = buttonHeight * config.maxScale;

            rings.forEach((ring) => {
                gsap.set(ring, {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    xPercent: -50,
                    yPercent: -50,
                    width: initialWidth,
                    height: initialHeight,
                    opacity: 0,
                });
            });

            rings.forEach((ring, index) => {
                const tlPosition = gsap.timeline({ repeat: -1 });

                const tlOpacity = gsap.timeline({ repeat: -1 });

                tlPosition.to(ring, {
                    duration: config.duration,
                    width: isMobile ? maxWidth * 0.75 : maxWidth,
                    height: isMobile ? maxHeight * 0.75 : maxHeight,
                    ease: 'linear',
                });

                tlOpacity
                    .to(ring, {
                        duration: config.fadeInDuration,
                        opacity: 1,
                        ease: 'linear',
                    })
                    .to(ring, {
                        duration: config.duration - config.fadeInDuration,
                        opacity: 0,
                        ease: 'linear',
                    });

                const progressOffset = (index * config.stagger) % 1;
                tlPosition.progress(progressOffset);
                tlOpacity.progress(progressOffset);

                timelines.push(tlPosition, tlOpacity);
            });
        }

        if (
            document.readyState === 'complete' ||
            document.readyState === 'interactive'
        ) {
            setupRings();
        } else {
            window.addEventListener('DOMContentLoaded', setupRings);
        }

        window.addEventListener('load', setupRings);

        let resizeTimeout;
        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                setupRings();
            }, 150);
        }
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            timelines.forEach((tl) => tl.kill());
            clearTimeout(resizeTimeout);
        };
    }

    function animateMobileGrid() {
        // Interactions are initialized at DOMContentLoaded via initMobileGridInteractions()
    }

    function initMobileGridInteractions() {
        if (window.innerWidth >= 1024) return;

        const track = document.getElementById('grid-mobile-track');
        if (!track) return;

        const buttons = Array.from(document.querySelectorAll('#grid-mobile-btn'));
        let currentIndex = 0;
        const columnCount = 3;

        const goToSlide = (index) => {
            currentIndex = Math.max(0, Math.min(columnCount - 1, index));
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
            buttons.forEach((btn, i) => {
                if (i === currentIndex) {
                    btn.classList.remove('bg-white/30');
                    btn.classList.add('bg-green');
                } else {
                    btn.classList.remove('bg-green');
                    btn.classList.add('bg-white/30');
                }
            });
        };

        buttons.forEach((btn, i) => {
            btn.addEventListener('click', () => goToSlide(i));
        });

        const swipeTarget = document.querySelector('#grid-mobile-pin-container > div');
        if (swipeTarget) {
            let touchStartX = 0;
            swipeTarget.addEventListener('touchstart', (e) => {
                touchStartX = e.touches[0].clientX;
            }, { passive: true });
            swipeTarget.addEventListener('touchend', (e) => {
                const diff = touchStartX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) {
                    goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
                }
            }, { passive: true });
        }
    }

    function animateRings(containerSelector, options = {}) {
        const baseConfig = {
            initialSize: options.initialSize || 100,
            maxScale: options.maxScale || 15,
            duration: options.duration || 10,
            fadeInDuration: options.fadeInDuration || 1,
            stagger: options.stagger || 0.25,
            rootMargin: options.rootMargin || '500px',
            forcePlay: options.forcePlay || false,
        };

        const container = document.querySelector(containerSelector);

        const rings = Array.from(container.querySelectorAll('[id^="ring-"]'));
        let timelines = [];
        let observer;

        const isHeroRings = containerSelector.includes('rings-hero');

        function updateConfig() {
            const config = { ...baseConfig };

            if (isBellow1024) {
                config.initialSize = config.initialSize / 1.25;
                config.maxScale = Math.max(2, config.maxScale / 2);
            }

            return config;
        }

        function setupRings() {
            timelines.forEach((tl) => tl.kill());
            timelines = [];

            const config = updateConfig();

            const initialWidth = config.initialSize;
            const initialHeight = config.initialSize;
            const maxWidth = initialWidth * config.maxScale;
            const maxHeight = initialHeight * config.maxScale;

            gsap.set(rings, {
                width: initialWidth,
                height: initialHeight,
                opacity: 0,
                position: 'absolute',
                top: '50%',
                left: '50%',
                xPercent: -50,
                yPercent: -50,
                borderRadius: '50%',
                // iOS Safari fixes for proper circular rendering
                WebkitBorderRadius: '50%',
                transform: 'translate3d(0, 0, 0)',
                WebkitTransform: 'translate3d(0, 0, 0)',
                backfaceVisibility: 'hidden',
                WebkitBackfaceVisibility: 'hidden',
                transformStyle: 'preserve-3d',
                WebkitTransformStyle: 'preserve-3d',
                // Additional Safari fixes
                willChange: 'transform, opacity, width, height',
                // WebkitMaskImage: '-webkit-radial-gradient(white, black)', // Forces Safari to respect border-radius during animations
                isolation: 'isolate', // Creates new stacking context
            });

            const shouldAutoPlay = isHeroRings || config.forcePlay;

            rings.forEach((ring, index) => {
                const tlPosition = gsap.timeline({
                    repeat: -1,
                    paused: !shouldAutoPlay,
                });

                const tlOpacity = gsap.timeline({
                    repeat: -1,
                    paused: !shouldAutoPlay,
                });

                tlPosition.to(ring, {
                    duration: config.duration,
                    width: maxWidth,
                    height: maxHeight,
                    ease: 'linear',
                });

                tlOpacity
                    .to(ring, {
                        duration: config.fadeInDuration,
                        opacity: 1,
                        ease: 'linear',
                    })
                    .to(ring, {
                        duration: config.duration - config.fadeInDuration,
                        opacity: 0,
                        ease: 'linear',
                    });

                const progressOffset = (index * config.stagger) % 1;
                tlPosition.progress(progressOffset);
                tlOpacity.progress(progressOffset);

                timelines.push(tlPosition, tlOpacity);
            });
        }

        function startAnimations() {
            timelines.forEach((timeline) => timeline.play());
        }

        function pauseAnimations() {
            if (isHeroRings) return;

            timelines.forEach((timeline) => timeline.pause());
        }

        function setupObserver() {
            if (observer) {
                observer.disconnect();
            }

            if (isHeroRings) {
                return;
            }

            const config = updateConfig();
            observer = new IntersectionObserver(
                (entries) => {
                    const [entry] = entries;
                    if (entry.isIntersecting) {
                        startAnimations();
                    } else {
                        pauseAnimations();
                    }
                },
                {
                    rootMargin: config.rootMargin,
                    threshold: 0,
                }
            );

            observer.observe(container);

            const rect = container.getBoundingClientRect();
            const isInViewport =
                rect.top + rect.height >= 0 &&
                rect.bottom - rect.height <=
                (window.innerHeight || document.documentElement.clientHeight) &&
                rect.left + rect.width >= 0 &&
                rect.right - rect.width <=
                (window.innerWidth || document.documentElement.clientWidth);

            if (isInViewport) {
                startAnimations();
            }
        }

        setupRings();
        setupObserver();

        let resizeTimeout;
        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                setupRings();
                setupObserver();
            }, 150);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            if (observer) {
                observer.disconnect();
            }
            window.removeEventListener('resize', handleResize);
            timelines.forEach((tl) => tl.kill());
            clearTimeout(resizeTimeout);
        };
    }

    function animateWhyCards() {
        const CARD_STACK_DISTANCE = '250%';
        const SCROLL_DISTANCE = isMobile ? '200%' : '300%';
        const CARD_SCALE_OFFSET = isMobile ? -10 : -20;
        const ANIMATION_DELAY = 0.15;
        const MOVE_DURATION = 0.75;
        const HEADING_REVEAL_THRESHOLDS = isMobile
            ? [null, 0.25, 0.65]
            : [null, 0.275, 0.65];
        const HEADING_ANIMATION = {
            duration: 0.8,
            staggerAmount: 0.6,
            ease: 'power2.out',
            initialY: 30,
        };

        const pinContainer = document.querySelector('#cards-pin');
        const cards = [
            document.getElementById('card-1'),
            document.getElementById('card-2'),
            document.getElementById('card-3'),
        ];
        const cardsHeadings = cards.map((card) => card?.querySelector('h3'));

        const headingRevealStatus = [false, false, false];
        const cardHeadingsSplit = cardsHeadings.map((heading) => {
            const splitText = new SplitText(heading, { type: 'lines, words' });
            gsap.set(splitText.words, {
                opacity: 0,
                y: HEADING_ANIMATION.initialY,
            });
            return splitText;
        });

        const resetHeading = (index) => {
            headingRevealStatus[index] = false;
            gsap.set(cardHeadingsSplit[index].words, {
                opacity: 0,
                y: HEADING_ANIMATION.initialY,
            });
        };

        const revealHeading = (index) => {
            if (headingRevealStatus[index]) return;
            headingRevealStatus[index] = true;

            gsap.to(cardHeadingsSplit[index].words, {
                opacity: 1,
                y: 0,
                duration: HEADING_ANIMATION.duration,
                stagger: {
                    amount: HEADING_ANIMATION.staggerAmount,
                    from: 'start',
                },
                ease: HEADING_ANIMATION.ease,
            });
        };

        const checkAndRevealHeadings = (progress) => {
            HEADING_REVEAL_THRESHOLDS.forEach((threshold, index) => {
                if (threshold !== null && progress >= threshold) {
                    revealHeading(index);
                }
            });
        };

        const resetAllHeadings = () => {
            headingRevealStatus.forEach((_, index) => resetHeading(index));
        };

        gsap.set([cards[1], cards[2]], { y: CARD_STACK_DISTANCE });

        ScrollTrigger.create({
            trigger: cards[0],
            start: 'top 88%',
            end: 'bottom top',
            onEnter: () => revealHeading(0),
            onEnterBack: () => revealHeading(0),
            onLeaveBack: () => resetHeading(0),
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: pinContainer,
                pin: mobile ? false : true,
                start: 'top-=100 top',
                end: `+=${SCROLL_DISTANCE}`,
                scrub: 1,
                onUpdate: (self) => checkAndRevealHeadings(self.progress),
                onEnterBack: (self) => {
                    resetAllHeadings();
                    checkAndRevealHeadings(self.progress);
                },
            },
        });

        tl.to({}, { duration: ANIMATION_DELAY })
            .to(
                cards[1],
                {
                    y: 0,
                    duration: MOVE_DURATION,
                    ease: 'power2.inOut',
                },
                '>'
            )
            .to(
                cards[0],
                {
                    scale: 0.9,
                    y: CARD_SCALE_OFFSET,
                    duration: MOVE_DURATION,
                    ease: 'power2.inOut',
                },
                '<'
            );

        tl.to({}, { duration: ANIMATION_DELAY })
            .to(
                cards[2],
                {
                    y: 0,
                    duration: MOVE_DURATION,
                    ease: 'power2.inOut',
                },
                '>'
            )
            .to(
                cards[1],
                {
                    scale: 0.9,
                    y: CARD_SCALE_OFFSET,
                    duration: MOVE_DURATION,
                    ease: 'power2.inOut',
                },
                '<'
            )
            .to(
                cards[0],
                {
                    scale: 0.8,
                    y: CARD_SCALE_OFFSET * 2,
                    duration: MOVE_DURATION,
                    ease: 'power2.inOut',
                },
                '<'
            )
            .to({}, { duration: 0.5 });
    }

    function animateMarquee() {
        const marqueeWrapper = document.querySelector('#marquee-container');
        const marqueeContent = document.querySelector('#marquee-container-inner');
        const marqueeSections = document.querySelectorAll('.marquee-section');

        if (!marqueeContent || !marqueeWrapper || !marqueeSections.length) return;

        const sectionWidth = marqueeSections[0].offsetWidth + 175;

        const tl = gsap.timeline({ repeat: -1 });

        gsap.set(marqueeContent, { x: -sectionWidth });

        tl.to(marqueeContent, {
            x: 0,
            duration: 20,
            ease: 'none',
        }).set(marqueeContent, {
            x: -sectionWidth,
        });

        marqueeWrapper.addEventListener('mouseenter', () => {
            tl.pause();
        });

        marqueeWrapper.addEventListener('mouseleave', () => {
            tl.resume();
        });

        return tl;
    }

    function animateTestimonials() {
        const testimonialsContainer = document.querySelector('#testimonials');
        const testimonialsPin = document.querySelector('.testimonials-pin');
        const testimonialsMobilePin = document.querySelector(
            '#testimonials-mobile-pin'
        );

        const states = {
            center: { left: '50%', scale: 1.0, zIndex: 30, y: 0 },
            left: { left: isMobile ? '35%' : '25%', scale: 0.8, zIndex: 20, y: 20 },
            right: { left: isMobile ? '65%' : '75%', scale: 0.8, zIndex: 20, y: 20 },
            back: { left: isMobile ? '50%' : '50%', scale: 0.6, zIndex: 10, y: 40 },
        };

        const cards = Array.from(
            testimonialsContainer.querySelectorAll('.testimonial-card')
        );
        let cardStates = ['center', 'left', 'back', 'right'];

        const animConfig = {
            baseDuration: 0.8,
            standardEase: 'power1.inOut',
            timing: {
                autoRotate: 5000,
            },
        };

        let observer = null;

        function createMobileScrollTimeline() {
            const masterTimeline = gsap.timeline();
            const totalSteps = 3;
            let tempCardStates = [...cardStates];

            for (let i = 0; i < totalSteps; i++) {
                const stepTimeline = gsap.timeline();
                const firstState = tempCardStates.shift();
                tempCardStates.push(firstState);

                cards.forEach((card, index) => {
                    const newState = tempCardStates[index];
                    const targetConfig = states[newState];
                    stepTimeline.to(
                        card,
                        {
                            left: targetConfig.left,
                            scale: targetConfig.scale,
                            y: targetConfig.y,
                            zIndex: targetConfig.zIndex,
                            ease: animConfig.standardEase,
                            duration: 1,
                        },
                        0
                    );
                });
                masterTimeline.add(stepTimeline);
            }
            return masterTimeline;
        }

        function createScrollTimeline() {
            const masterTimeline = gsap.timeline();
            const totalSteps = cards.length - 1;
            let tempCardStates = [...cardStates];

            for (let i = 0; i < totalSteps; i++) {
                const stepTimeline = gsap.timeline();
                const firstState = tempCardStates.shift();
                tempCardStates.push(firstState);

                cards.forEach((card, index) => {
                    const newState = tempCardStates[index];
                    const targetConfig = states[newState];
                    stepTimeline.to(
                        card,
                        {
                            left: targetConfig.left,
                            scale: targetConfig.scale,
                            y: targetConfig.y,
                            zIndex: targetConfig.zIndex,
                            ease: animConfig.standardEase,
                            duration: 1,
                        },
                        0
                    );
                });
                masterTimeline.add(stepTimeline);
            }
            return masterTimeline;
        }

        function initializeCards() {
            cards.forEach((card, index) => {
                const state = cardStates[index];
                const stateConfig = states[state];
                gsap.set(card, {
                    left: stateConfig.left,
                    scale: stateConfig.scale,
                    y: stateConfig.y,
                    zIndex: stateConfig.zIndex,
                    xPercent: -50,
                });
            });
        }

        initializeCards();

        function syncTestimonialVideos() {
            let rafId = null;
            let lastFrontCard = null;
            let allowedCard = null; // only this card may play

            function isFront(card) {
                const maxZ = Math.max(...cards.map(c => parseFloat(c.style.zIndex || 0)));
                return parseFloat(card.style.zIndex || 0) >= maxZ;
            }

            function stopCard(card) {
                if (card === allowedCard) allowedCard = null;
                const video = card.querySelector('video');
                if (video) { video.pause(); video.currentTime = 0; }
            }

            function stopAll() {
                allowedCard = null;
                if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
                lastFrontCard = null;
                cards.forEach(card => {
                    const video = card.querySelector('video');
                    const btn = card.querySelector('.testimonial-play-btn');
                    if (video) { video.pause(); video.currentTime = 0; }
                    if (btn) { btn.style.opacity = '0'; btn.style.pointerEvents = 'none'; }
                });
            }

            function preloadCard(card) {
                const video = card.querySelector('video');
                if (!video) return;
                const source = video.querySelector('source[data-src]');
                if (source && !source.getAttribute('src')) {
                    source.setAttribute('src', source.getAttribute('data-src'));
                    video.load(); // loads metadata + shows first frame, no play
                }
            }

            function playCard(card) {
                allowedCard = card;
                const video = card.querySelector('video');
                const btn = card.querySelector('.testimonial-play-btn');
                if (!video) return;
                const source = video.querySelector('source[data-src]');
                if (source && !source.getAttribute('src')) {
                    source.setAttribute('src', source.getAttribute('data-src'));
                    video.load();
                    video.addEventListener('canplay', () => {
                        if (allowedCard !== card) return; // permission revoked while loading
                        video.play().catch(() => { });
                        if (btn) { btn.style.opacity = '0'; btn.style.pointerEvents = 'none'; }
                    }, { once: true });
                } else {
                    video.play().catch(() => { });
                    if (btn) { btn.style.opacity = '0'; btn.style.pointerEvents = 'none'; }
                }
            }

            // Wire up click handlers once
            cards.forEach(card => {
                const btn = card.querySelector('.testimonial-play-btn');
                const video = card.querySelector('video');
                if (!btn || !video) return;

                card.addEventListener('click', () => {
                    if (!isFront(card)) return;
                    if (video.paused) {
                        playCard(card);
                    } else {
                        allowedCard = null;
                        video.pause();
                        if (btn) { btn.style.opacity = '1'; btn.style.pointerEvents = 'auto'; }
                    }
                });
            });

            // rAF: manage button visibility + stop non-front videos on carousel rotation
            function tick() {
                let frontCard = null;
                let maxZ = -1;
                cards.forEach(card => {
                    const z = parseInt(card.style.zIndex || 0);
                    if (z > maxZ) { maxZ = z; frontCard = card; }
                });
                if (frontCard !== lastFrontCard) {
                    lastFrontCard = frontCard;
                    cards.forEach(card => {
                        const btn = card.querySelector('.testimonial-play-btn');
                        if (card !== frontCard) {
                            stopCard(card);
                            if (btn) { btn.style.opacity = '0'; btn.style.pointerEvents = 'none'; }
                        } else {
                            const video = card.querySelector('video');
                            if (btn && video && video.paused) { btn.style.opacity = '1'; btn.style.pointerEvents = 'auto'; }
                        }
                    });
                }
                rafId = requestAnimationFrame(tick);
            }

            let preloaded = false;
            const sectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!preloaded) {
                            preloaded = true;
                            cards.forEach(preloadCard); // load src + show first frame for all cards
                        }
                        stopAll(); // ensure clean state before starting
                        rafId = requestAnimationFrame(tick);
                    } else {
                        stopAll();
                    }
                });
            }, { threshold: 0.1 });

            const observeTarget = testimonialsPin || testimonialsContainer;
            if (observeTarget) sectionObserver.observe(observeTarget);
        }

        syncTestimonialVideos();

        if (!isBellow1024) {
            const scrollTimeline = createScrollTimeline();
            gsap
                .timeline({
                    scrollTrigger: {
                        trigger: testimonialsPin,
                        pin: true,
                        start: 'top top',
                        markers: false,
                        end:
                            window.innerHeight > 950
                                ? 'bottom 85%'
                                : window.innerHeight > 850
                                    ? 'bottom 90%'
                                    : 'bottom 100%',
                        scrub: true,
                    },
                })
                .add(scrollTimeline);
        } else {
            // ---- MOBILE SWIPE VERSION ---- //

            let isDragging = false;
            let startX = 0;
            let deltaX = 0;
            let currentIndex = 0; // tracks rotation state
            let verticalLock = false; // prevents horizontal swipe from blocking scroll

            // === Mobile dots ===
            const dots = gsap.utils.toArray("#testimonial-dots .dot");

            function setActiveDot(index) {
                dots.forEach((dot, i) => {
                    dot.style.backgroundColor = i === index
                        ? "#08d650"
                        : "rgba(255,255,255,0.3)";
                });
            }

            function updateTestimonialNav(newIndex) {
                setActiveDot(newIndex);
            }

            // === Apply card state order based on rotation ===
            function applyStates() {
                let rotated = [...cardStates];

                // apply rotation based on currentIndex
                for (let i = 0; i < currentIndex; i++) {
                    rotated.push(rotated.shift());
                }

                cards.forEach((card, index) => {
                    const s = states[rotated[index]];

                    gsap.to(card, {
                        left: s.left,
                        scale: s.scale,
                        y: s.y,
                        zIndex: s.zIndex,
                        duration: 0.45,
                        ease: "power2.out"
                    });
                });

                updateTestimonialNav(currentIndex);
            }

            // === Touch handlers ===
            testimonialsContainer.addEventListener("touchstart", (e) => {
                isDragging = true;
                verticalLock = false;
                startX = e.touches[0].clientX;
            });

            testimonialsContainer.addEventListener("touchmove", (e) => {
                if (!isDragging) return;

                const moveX = e.touches[0].clientX - startX;
                deltaX = moveX;

                // If user is swiping horizontally → prevent screen scroll
                if (!verticalLock && Math.abs(deltaX) > 10) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, { passive: false });

            testimonialsContainer.addEventListener("touchend", () => {
                if (!isDragging) return;
                isDragging = false;

                if (Math.abs(deltaX) > 40) {
                    if (deltaX < 0) {
                        // swipe left → next card
                        currentIndex = (currentIndex + 1) % cards.length;
                    } else {
                        // swipe right → previous card
                        currentIndex = (currentIndex - 1 + cards.length) % cards.length;
                    }
                    applyStates();
                }

                deltaX = 0;
            });

            // Initialize states & dots
            applyStates();
        }


        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }

    function animateSimplicityTitle() {
        const simplicityText = document.getElementById('simplicity-text');
        const simplicitySection = document.getElementById('simplicity');

        if (!simplicityText || !simplicitySection) {
            console.warn('Simplicity text or simplicity section not found');
            return;
        }

        if (window.location.pathname === '/b') {
            gsap.set(simplicityText, {
                x: isMobile ? '50%' : '120%',
            });

            gsap.to(simplicityText, {
                x: isMobile ? '-90%' : '-51%',
                ease: 'none',
                scrollTrigger: {
                    trigger: simplicitySection,
                    start: 'top-=100 top',
                    end: 'bottom bottom-=250',
                    scrub: 2,
                    markers: false,
                },
            });
        } else {
            gsap.set(simplicityText, {
                x: isMobile ? '50%' : '75%',
            });

            gsap.to(simplicityText, {
                x: isMobile ? '-90%' : '-80%',
                ease: 'none',
                scrollTrigger: {
                    trigger: simplicitySection,
                    start: 'top-=100 top',
                    end: 'bottom bottom',
                    scrub: 2,
                    markers: false,
                },
            });
        }

    }

    function animateTags() {
        const tagsContainer = document.querySelector('#tags-container');
        if (!tagsContainer) return;

        const speedMultipliers = [1, 1.4, 0.6, 1.7, 0.7, 1.5, 1.1];
        const baseDuration = 120;
        let observer;

        const observerConfig = {
            rootMargin: '250px',
            threshold: 0,
        };

        const tagRows = [
            {
                row: document.querySelector('#tags-row-1'),
                first: document.querySelector('#tags-row-1-first'),
                second: document.querySelector('#tags-row-1-second'),
                third: document.querySelector('#tags-row-1-third'),
            },
            {
                row: document.querySelector('#tags-row-2'),
                first: document.querySelector('#tags-row-2-first'),
                second: document.querySelector('#tags-row-2-second'),
                third: document.querySelector('#tags-row-2-third'),
            },
            {
                row: document.querySelector('#tags-row-3'),
                first: document.querySelector('#tags-row-3-first'),
                second: document.querySelector('#tags-row-3-second'),
                third: document.querySelector('#tags-row-3-third'),
            },
            {
                row: document.querySelector('#tags-row-4'),
                first: document.querySelector('#tags-row-4-first'),
                second: document.querySelector('#tags-row-4-second'),
                third: document.querySelector('#tags-row-4-third'),
            },
            {
                row: document.querySelector('#tags-row-5'),
                first: document.querySelector('#tags-row-5-first'),
                second: document.querySelector('#tags-row-5-second'),
                third: document.querySelector('#tags-row-5-third'),
            },
            {
                row: document.querySelector('#tags-row-6'),
                first: document.querySelector('#tags-row-6-first'),
                second: document.querySelector('#tags-row-6-second'),
                third: document.querySelector('#tags-row-6-third'),
            },
            {
                row: document.querySelector('#tags-row-7'),
                first: document.querySelector('#tags-row-7-first'),
                second: document.querySelector('#tags-row-7-second'),
                third: document.querySelector('#tags-row-7-third'),
            },
        ];

        function setupTagAnimations() {
            tagRows.forEach((tagRow, index) => {
                if (!tagRow.row || !tagRow.first || !tagRow.second || !tagRow.third)
                    return;

                const sectionWidth = tagRow.first.offsetWidth + 8;

                const direction = (index + 1) % 2 === 1 ? -1 : 1;

                const speedMultiplier = speedMultipliers[index] || 1;
                const duration = baseDuration / speedMultiplier;

                const tl = gsap.timeline({ repeat: -1, paused: true });

                if (direction === -1) {
                    gsap.set(tagRow.row, { x: 0 });

                    tl.to(tagRow.row, {
                        x: -sectionWidth,
                        duration: duration,
                        ease: 'none',
                    }).set(tagRow.row, {
                        x: 0,
                    });
                } else {
                    gsap.set(tagRow.row, { x: -sectionWidth });

                    tl.to(tagRow.row, {
                        x: 0,
                        duration: duration,
                        ease: 'none',
                    }).set(tagRow.row, {
                        x: -sectionWidth,
                    });
                }

                tagRow.row.addEventListener('mouseenter', () => {
                    if (tl.isActive()) {
                        tl.pause();
                    }
                });

                tagRow.row.addEventListener('mouseleave', () => {
                    if (tagRow.isVisible) {
                        tl.resume();
                    }
                });

                tagRow.timeline = tl;
                tagRow.isVisible = false;
            });
        }

        function startTagAnimations() {
            tagRows.forEach((tagRow) => {
                if (tagRow.timeline) {
                    tagRow.timeline.play();
                    tagRow.isVisible = true;
                }
            });
        }

        function pauseTagAnimations() {
            tagRows.forEach((tagRow) => {
                if (tagRow.timeline) {
                    tagRow.timeline.pause();
                    tagRow.isVisible = false;
                }
            });
        }

        function setupObserver() {
            if (observer) {
                observer.disconnect();
            }

            observer = new IntersectionObserver((entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    startTagAnimations();
                } else {
                    pauseTagAnimations();
                }
            }, observerConfig);

            observer.observe(tagsContainer);

            const rect = tagsContainer.getBoundingClientRect();
            const isInViewport =
                rect.top + rect.height >= 0 &&
                rect.bottom - rect.height <=
                (window.innerHeight || document.documentElement.clientHeight) &&
                rect.left + rect.width >= 0 &&
                rect.right - rect.width <=
                (window.innerWidth || document.documentElement.clientWidth);

            if (isInViewport) {
                startTagAnimations();
            }
        }

        setupTagAnimations();
        setupObserver();

        return () => {
            if (observer) {
                observer.disconnect();
            }
            tagRows.forEach((tagRow) => {
                if (tagRow.timeline) {
                    tagRow.timeline.kill();
                }
            });
        };
    }

    function initVideoPreview() {
        if (isMobile) return;
        const existingPreview = document.querySelector('#video-preview');
        if (existingPreview) {
            existingPreview.remove();
        }

        const videoPreview = document.createElement('div');
        videoPreview.id = 'video-preview';
        videoPreview.style.position = 'absolute';
        videoPreview.style.zIndex = '9999';
        videoPreview.style.pointerEvents = 'none';
        videoPreview.style.opacity = '0';
        videoPreview.style.transition = 'opacity 0.2s ease';
        videoPreview.style.width = '220px';
        videoPreview.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
        videoPreview.style.overflow = 'hidden';
        videoPreview.style.borderRadius = '8px';
        videoPreview.style.backgroundColor = '#000';

        const previewVideo = document.createElement('video');
        previewVideo.id = 'preview-video';
        previewVideo.style.width = '100%';
        previewVideo.style.height = 'auto';
        previewVideo.style.display = 'block';
        previewVideo.muted = true;
        previewVideo.playsInline = true;
        previewVideo.autoplay = true;

        videoPreview.appendChild(previewVideo);
        document.body.appendChild(videoPreview);

        const videoUrls = [
            'assets/videos/tags-travel.mp4',
            'assets/videos/tags-comedy.mp4',
            'assets/videos/tags-minimalism.mp4',
            'assets/videos/tags-dancing.mp4',
            'assets/videos/tags-pet.mp4',
            'assets/videos/tags-skateboarding.mp4',
            'assets/videos/tags-timelapse.mp4',
        ];
        const highlightedTags = document.querySelectorAll('.tag-highlight');

        highlightedTags.forEach((tag) => {
            const videoClass = Array.from(tag.classList).find((cls) =>
                cls.startsWith('video-')
            );
            const videoIndex = videoClass ? parseInt(videoClass.split('-')[1]) - 1 : 0;

            tag.addEventListener('mouseenter', (e) => {
                const videoSrc = videoUrls[videoIndex] || videoUrls[0];
                previewVideo.src = videoSrc;
                previewVideo.play().catch((err) => console.log('Video play error:', err));

                videoPreview.style.opacity = '1';

                const offsetX = 20;
                const offsetY = 20;

                const updatePosition = (event) => {
                    const mouseX = event.pageX;
                    const mouseY = event.pageY;
                    const viewportWidth = window.innerWidth;

                    const shouldFlipX =
                        event.clientX + videoPreview.offsetWidth + offsetX > viewportWidth;

                    if (shouldFlipX) {
                        videoPreview.style.left = `${mouseX - videoPreview.offsetWidth - offsetX
                            }px`;
                    } else {
                        videoPreview.style.left = `${mouseX + offsetX}px`;
                    }

                    videoPreview.style.top = `${mouseY + offsetY}px`;
                };

                updatePosition(e);

                tag._positionUpdater = updatePosition;

                document.addEventListener('mousemove', updatePosition);
            });

            tag.addEventListener('mouseleave', () => {
                videoPreview.style.opacity = '0';
                previewVideo.pause();
                previewVideo.currentTime = 0;

                if (tag._positionUpdater) {
                    document.removeEventListener('mousemove', tag._positionUpdater);
                    delete tag._positionUpdater;
                }
            });
        });
    }

    function animateStripeIphone() {
        if (isMobile) return;
        const stripeIphone = document.getElementById('stripe-iphone');
        if (!stripeIphone) return;

        let mouseX = 0;
        let mouseY = 0;
        let currentX = 0;
        let currentY = 0;

        const config = {
            maxMovement: 40,
            smoothing: 0.1,
            sensitivity: 0.3,
        };

        function updateMousePosition(e) {
            const rect = stripeIphone.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const relativeX = (e.clientX - centerX) / (window.innerWidth / 2);
            const relativeY = (e.clientY - centerY) / (window.innerHeight / 2);

            mouseX =
                Math.max(-1, Math.min(1, relativeX * config.sensitivity)) *
                config.maxMovement;
            mouseY =
                Math.max(-1, Math.min(1, relativeY * config.sensitivity)) *
                config.maxMovement;
        }

        function animate() {
            currentX += (mouseX - currentX) * config.smoothing;
            currentY += (mouseY - currentY) * config.smoothing;

            gsap.set(stripeIphone, {
                x: currentX,
                y: currentY,
                ease: 'none',
            });

            requestAnimationFrame(animate);
        }

        document.addEventListener('mousemove', updateMousePosition);

        animate();

        return () => {
            document.removeEventListener('mousemove', updateMousePosition);
        };
    }

    function animateFAQQuestions() {
        const faqItems = document.querySelectorAll('.faq-item');

        if (!faqItems.length) return;

        faqItems.forEach((item) => {
            const answer = item.querySelector('.faq-answer');
            const arrow = item.querySelector('.faq-arrow');
            const icon = item.querySelector('.faq-icon');
            const question = item.querySelector('h4');
            const answerText = item.querySelector('.faq-answer p');
            const arrowPaths = item.querySelectorAll('.faq-arrow path');
            const bgColor = '#08d650';

            gsap.set(answer, { height: 0 });
            gsap.set(arrow, { rotation: 0 });
            gsap.set(icon, { backgroundColor: bgColor });
            gsap.set(question, { color: '#FFFFFF' });
            gsap.set(answerText, { color: '#FFFFFF' });
            arrowPaths.forEach((path) => {
                gsap.set(path, { fill: '#000000' });
            });

            item.isOpen = false;

            item.addEventListener('click', () => {
                const currentAnswer = item.querySelector('.faq-answer');
                const currentArrow = item.querySelector('.faq-arrow');
                const currentIcon = item.querySelector('.faq-icon');
                const currentQuestion = item.querySelector('h4');
                const currentAnswerText = item.querySelector('.faq-answer p');
                const currentArrowPaths = item.querySelectorAll('.faq-arrow path');

                if (!item.isOpen) {
                    const timeline = gsap.timeline();

                    gsap.set(currentAnswer, { height: 'auto' });
                    const autoHeight = currentAnswer.offsetHeight;
                    gsap.set(currentAnswer, { height: 0 });

                    timeline
                        .to(item, {
                            backgroundColor: bgColor,
                            duration: 0.2,
                            ease: 'power2.inOut',
                        })
                        .to(
                            currentIcon,
                            {
                                backgroundColor: '#121212',
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            [currentQuestion, currentAnswerText],
                            {
                                color: '#121212',
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            currentAnswer,
                            {
                                height: autoHeight,
                                duration: 0.4,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            currentArrow,
                            {
                                rotation: 180,
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        );

                    currentArrowPaths.forEach((path) => {
                        gsap.to(path, {
                            fill: bgColor,
                            duration: 0.4,
                            ease: 'power2.inOut',
                        });
                    });

                    item.isOpen = true;
                } else {
                    const timeline = gsap.timeline();

                    timeline
                        .to(currentAnswer, {
                            height: 0,
                            duration: 0.4,
                            ease: 'power2.inOut',
                        })
                        .to(
                            currentArrow,
                            {
                                rotation: 0,
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            item,
                            {
                                backgroundColor: '#1C1C1C',
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            [currentQuestion, currentAnswerText],
                            {
                                color: '#FFFFFF',
                                duration: 0.4,
                                ease: 'power2.inOut',
                            },
                            '<'
                        )
                        .to(
                            currentIcon,
                            {
                                backgroundColor: bgColor,
                                duration: 0.2,
                                ease: 'power2.inOut',
                            },
                            '<'
                        );

                    currentArrowPaths.forEach((path) => {
                        gsap.to(path, {
                            fill: '#000000',
                            duration: 0.2,
                            ease: 'power2.inOut',
                        });
                    });

                    item.isOpen = false;
                }
            });
        });
    }

    function updateYear() {
        const yearElement = document.getElementById('year');
        if (yearElement) {
            const currentYear = new Date().getFullYear();
            yearElement.textContent = `@ ${currentYear} Watchimo - All rights Reserved`;
        }
    }

    function animateCheatSheet() {
        const cheatsheetWrapper = document.getElementById('cheatsheet-wrapper');
        const cheatsheetContent = document.getElementById('cheatsheet-content');
        const cheatsheetToggle = document.getElementById('cheatsheet-toggle');
        const cheatsheetCloseIcon = document.getElementById('cheatsheet-close');
        const cheatsheetSection = document.getElementById('cheatsheet');
        const monetizeSection = document.getElementById('monetize');

        if (!cheatsheetWrapper || !cheatsheetContent) return;

        let isOpen = false;
        let hoverTimeout = null;
        let scrollTriggerInstance = null;

        // Initially hide the cheatsheet wrapper
        gsap.set(cheatsheetWrapper, {
            opacity: 0,
            pointerEvents: 'none'
        });

        // ScrollTrigger to show/hide based on monetize section
        if (monetizeSection) {
            scrollTriggerInstance = ScrollTrigger.create({
                trigger: monetizeSection,
                start: 'top bottom',
                end: 'bottom bottom',
                onEnter: () => {
                    gsap.to(cheatsheetWrapper, {
                        opacity: 1,
                        pointerEvents: 'auto',
                        duration: 0.4,
                        ease: 'power2.out'
                    });
                },
                onLeaveBack: () => {
                    gsap.to(cheatsheetWrapper, {
                        opacity: 0,
                        pointerEvents: 'none',
                        duration: 0.4,
                        ease: 'power2.in'
                    });
                }
            });
        }

        const getContentWidth = () => cheatsheetContent.offsetWidth || 0;

        const openCheatSheet = () => {
            const contentWidth = getContentWidth();
            gsap.to(cheatsheetWrapper, {
                x: -contentWidth,
                duration: 0.6,
                ease: 'power2.out',
            });
            isOpen = true;
        };

        const closeCheatSheet = () => {
            gsap.to(cheatsheetWrapper, {
                x: 0,
                duration: 0.6,
                ease: 'power2.in',
            });
            isOpen = false;
        };

        const toggleHandler = (e) => {
            if (e && e.stopPropagation) e.stopPropagation();
            if (!isOpen) openCheatSheet();
            else closeCheatSheet();
        };

        // Hover handlers for non-mobile devices
        const handleMouseEnter = () => {
            if (isMobile) return; // Only work on non-mobile devices
            clearTimeout(hoverTimeout);
            if (!isOpen) openCheatSheet();
        };

        const handleMouseLeave = () => {
            if (isMobile) return; // Only work on non-mobile devices
            clearTimeout(hoverTimeout);
            hoverTimeout = setTimeout(() => {
                if (isOpen) closeCheatSheet();
            }, 300); // Small delay before closing
        };

        // Add click listeners for mobile and as fallback
        [cheatsheetCloseIcon, cheatsheetToggle].forEach((el) => {
            if (!el) return;
            el.addEventListener('click', toggleHandler);
        });

        // Add hover listeners for non-mobile
        if (cheatsheetSection) {
            cheatsheetSection.addEventListener('mouseenter', handleMouseEnter);
            cheatsheetSection.addEventListener('mouseleave', handleMouseLeave);
        }

        let resizeTimer = null;
        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (isOpen) {
                    const updatedWidth = getContentWidth();
                    gsap.set(cheatsheetWrapper, { x: -updatedWidth });
                }
            }, 120);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            [cheatsheetCloseIcon, cheatsheetToggle].forEach((el) => {
                if (!el) return;
                el.removeEventListener('click', toggleHandler);
            });
            if (cheatsheetSection) {
                cheatsheetSection.removeEventListener('mouseenter', handleMouseEnter);
                cheatsheetSection.removeEventListener('mouseleave', handleMouseLeave);
            }
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
            if (scrollTriggerInstance) {
                scrollTriggerInstance.kill();
            }
            clearTimeout(resizeTimer);
            clearTimeout(hoverTimeout);
        };
    }

    function parallaxAnimation() {
        const parallaxElements = document.querySelectorAll('.parallax');

        parallaxElements.forEach((element) => {
            const htmlElement = element;

            gsap.to(element, {
                y: (i, target) => {
                    const targetElement = target;
                    const isMobile = window.innerWidth < 768;
                    const elementSpeed =
                        isMobile && targetElement.dataset.speedMobile
                            ? parseFloat(targetElement.dataset.speedMobile)
                            : parseFloat(targetElement.dataset.speed || '-1.5');
                    return elementSpeed * 100;
                },
                ease: 'none',
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });
        });
    }

    function animateToView() {
        const animateElements = (selector, fromProps, staggerOptions = null) => {
            const elements = document.querySelectorAll(selector);
            if (!elements.length) return;

            const isVisible = (el) => {
                return !!(
                    el.offsetWidth ||
                    el.offsetHeight ||
                    el.getClientRects().length
                );
            };

            const visibleElements = Array.from(elements).filter(isVisible);
            if (!visibleElements.length) return;

            const elementsByParent = {};
            visibleElements.forEach((element) => {
                const parent = element.parentElement;
                const parentKey = parent.tagName + (parent.id ? '#' + parent.id : '');
                if (!elementsByParent[parentKey]) {
                    elementsByParent[parentKey] = {
                        parent,
                        elements: [],
                    };
                }
                elementsByParent[parentKey].elements.push(element);
            });

            Object.values(elementsByParent).forEach((group) => {
                if (staggerOptions && !isMobile) {
                    const hasNoReverse = group.elements.some(
                        (el) => el.classList && el.classList.contains('no-reverse-on-scroll')
                    );
                    const toggleActions = hasNoReverse
                        ? 'play none none reverse'
                        : 'play none none reverse';
                    gsap.from(group.elements, {
                        ...fromProps,
                        stagger: 0.3,
                        scrollTrigger: {
                            trigger: group.parent,
                            start: 'top 85%',
                            end: '+=20% 5%',
                            toggleActions,
                            markers: false,
                        },
                    });
                } else {
                    group.elements.forEach((element) => {
                        const hasNoReverse =
                            element.classList &&
                            element.classList.contains('no-reverse-on-scroll');
                        const toggleActions = hasNoReverse
                            ? 'play none none reverse'
                            : 'play none none reverse';
                        gsap.from(element, {
                            ...fromProps,
                            scrollTrigger: {
                                trigger: element,
                                start: 'top 85%',
                                end: '+=20% 5%',
                                toggleActions,
                                markers: false,
                            },
                        });
                    });
                }
            });
        };

        animateElements('.animate-to-view', {
            opacity: 0,
            scale: 0.95,
            ease: 'power2.out',
            duration: 0.8,
        });

        animateElements('.scale-to-view', {
            opacity: 0,
            scale: 0.5,
            ease: 'power2.out',
            duration: 0.8,
        });

        animateElements('.bounce-to-view', {
            opacity: 0,
            scale: 0.5,
            ease: 'elastic',
            duration: 1.2,
            delay: 0.5,
        });

        animateElements(
            '.animate-to-view-left',
            isMobile ? { opacity: 0, scale: 0.95 } : { opacity: 0, x: -50 }
        );

        animateElements(
            '.animate-to-view-right',
            isMobile ? { opacity: 0, scale: 0.95 } : { opacity: 0, x: 50 }
        );

        const shareViewElements = document.querySelectorAll(
            '.animate-to-view-1, .animate-to-view-2, .animate-to-view-3'
        );
        const sharePointElements = document.querySelectorAll(
            '#share-point-1, #share-point-2, #share-point-3'
        );

        if (shareViewElements.length || sharePointElements.length) {
            const allElements = [...shareViewElements, ...sharePointElements];
            const parent = allElements[0]?.parentElement;

            if (parent) {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: parent,
                        start: 'top 85%',
                        end: '+=20% 5%',
                        toggleActions: 'play none none reverse',
                        markers: false,
                    },
                });

                tl.from(
                    shareViewElements,
                    {
                        opacity: 0,
                        y: isMobile ? 0 : 30,
                        scale: isMobile ? 0.95 : 1,
                        duration: 0.8,
                        ease: 'power2.out',
                        stagger: 0.3,
                    },
                    0
                );

                tl.from(
                    sharePointElements,
                    {
                        opacity: 0,
                        scale: 0.5,
                        duration: 1.2,
                        ease: 'elastic',
                        stagger: 0.3,
                    },
                    0
                );
            }
        }
    }

    function animateGridHeadings() {
        const marquees = document.querySelectorAll('.grid-headings-marquee');
        if (!marquees.length) return;

        marquees.forEach((marquee) => {
            const marqueeTitle = marquee.querySelector('h4');
            if (!marqueeTitle) return;

            const titleWidth = marqueeTitle.offsetWidth;
            const animationWidth = titleWidth + 96;

            const speed = 250;
            const duration = animationWidth / speed;

            gsap.set(marquee, { x: 0 });

            const tl = gsap.timeline({ repeat: -1 });
            tl.to(marquee, {
                x: -animationWidth,
                duration: duration,
                ease: 'linear',
            }).set(marquee, { x: 0 });

            marquee._timeline = tl;
        });
    }

    function animateTexts() {
        const textElements = document.querySelectorAll('.animate-text');
        if (!textElements.length) return null;

        const fontsLoaded = document.fonts.ready
            .then(() => {
                const splitTexts = [];

                textElements.forEach((textElement) => {
                    const splitText = new SplitText(textElement, {
                        type: 'words',
                        aria: false,
                    });
                    splitTexts.push(splitText);

                    const hasNoReverse = textElement.classList.contains(
                        'no-reverse-on-scroll'
                    );
                    const toggleActions = hasNoReverse
                        ? 'play none none reverse'
                        : 'play none none reverse';

                    // Duration (existing)
                    let duration = 0.8;
                    const durationClass = Array.from(textElement.classList).find((cls) =>
                        /^animate-text-duration-\d+$/.test(cls)
                    );
                    if (durationClass) {
                        const match = durationClass.match(/animate-text-duration-(\d+)/);
                        if (match) {
                            const parsed = parseInt(match[1], 10);
                            if (!isNaN(parsed)) duration = parsed / 1000;
                        }
                    }

                    // Optional start override via class: animate-text-start-<number>
                    // e.g. animate-text-start-75 will use "top 75%"
                    let startPercent = 85;
                    const startClass = Array.from(textElement.classList).find((cls) =>
                        /^animate-text-start-\d+$/.test(cls)
                    );
                    if (startClass) {
                        const match = startClass.match(/animate-text-start-(\d+)/);
                        if (match) {
                            const parsedStart = parseInt(match[1], 10);
                            if (!isNaN(parsedStart)) startPercent = parsedStart;
                        }
                    }
                    const startValue = `top ${startPercent}%`;

                    gsap.from(splitText.words, {
                        opacity: 0,
                        y: 30,
                        duration,
                        stagger: {
                            amount: Math.max(0, duration - 0.2),
                            from: 'start',
                        },
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: textElement,
                            markers: false,
                            start: startValue,
                            end: 'top 5%',
                            toggleActions,
                        },
                    });
                });

                return () => {
                    splitTexts.forEach((splitText) => {
                        if (splitText.revert) splitText.revert();
                    });
                };
            })
            .catch((error) => {
                console.error('Error loading fonts:', error);
                return null;
            });

        return fontsLoaded;
    }



    function initPostPreloaderAnimations() {
        animateSimplicityTitle();
        animateMobileGrid();
        animateGridHeadings();
        animateMarquee();
        animateTestimonials();
        animateFAQQuestions();

        animateRings('#rings-monetize', {
            initialSize: 100,
            maxScale: 10,
        });

        animateRings('#rings-simplicity', {
            initialSize: 100,
            maxScale: 10,
        });

        animateRings('#rings-stripe', {
            initialSize: 100,
            maxScale: 12.5,
        });

        animateButtonRings('#rings-button', {
            initialScale: 0.9,
            maxScale: 2.5,
        });

        animateTags();

        if (!isMobile) {
            initVideoPreview();
            animateStripeIphone();
        }

        updateYear();
    }

    function initImmediateAnimations() {
        animateRings('#rings-hero', {
            initialSize: 50,
            maxScale: 45,
            forcePlay: true,
            rootMargin: '0px',
        });
        if (!mobile) {
            animateWhyCards();
        }


        const textAnimCleanup = animateTexts();
        animateToView();
        parallaxAnimation();
    }

    // Start hero title rotation as early as possible
    document.addEventListener('DOMContentLoaded', () => {
        animateHeroTitle();
        initMobileGridInteractions();

        // Hide preloader immediately on mobile — don't show it at all
        if (isMobile) {
            const preloaderEl = document.getElementById('initial-animation');
            if (preloaderEl) preloaderEl.style.display = 'none';
        }
    });

    window.addEventListener('load', () => {
        updateViewportStatus();

        initVideoOptimization();

        // Skip preloader animation - run post-preloader init immediately
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.body.classList.remove('preloader-active');
        document.documentElement.classList.remove('preloader-active');
        if (lenis) lenis.start();

        // Defer so browser finishes layout before ScrollTrigger measures
        setTimeout(() => {
            ScrollTrigger.refresh();
            initPostPreloaderAnimations();
        }, 100);

        initImmediateAnimations();

        if (!isMobile) {
            const preloaderEl = document.getElementById('initial-animation');
            if (preloaderEl) preloaderEl.style.display = 'none';
        }

        animateCheatSheet();

        initVideoModal(lenis);
    });

    function initVideoModal(lenis) {
        const modal = document.getElementById('video-modal');
        const modalBackdrop = document.getElementById('video-modal-backdrop');
        const modalContent = document.getElementById('video-modal-content');
        const modalCloseButtons = document.querySelectorAll('.video-modal-close');
        const modalVideo = document.getElementById('video-modal-video');
        const heroButton = document.getElementById('hero-button');

        if (!modal || !heroButton || !modalVideo) return;

        modalVideo.pause();

        // Function to open modal
        const openModal = () => {
            // Pause Lenis smooth scroll
            if (lenis) {
                lenis.stop();
            }

            // Prevent body scroll
            document.body.style.overflow = 'hidden';

            // Reset content state before animating
            gsap.set(modalContent, { scale: 0.9, opacity: 0 });

            // Show modal
            gsap.set(modal, { visibility: 'visible', pointerEvents: 'auto' });

            // Animate modal in
            const tl = gsap.timeline();

            // Fade in backdrop
            tl.to(modal, {
                opacity: 1,
                duration: 0.3,
                ease: 'power2.out',
            });

            // Scale and fade in content
            tl.to(modalContent, {
                scale: 1,
                opacity: 1,
                duration: 0.4,
                ease: 'power2.out',
            }, '-=0.1');

            // Restart and play video
            modalVideo.currentTime = 0;
            modalVideo.play().catch(err => console.log('Video play error:', err));
        };

        // Function to close modal
        const closeModal = () => {
            // Pause video immediately
            modalVideo.pause();

            // Animate modal out
            const tl = gsap.timeline({
                onComplete: () => {
                    // Hide modal
                    gsap.set(modal, { visibility: 'hidden', pointerEvents: 'none' });

                    // Resume Lenis smooth scroll
                    if (lenis) {
                        lenis.start();
                    }

                    // Allow body scroll
                    document.body.style.overflow = '';
                }
            });

            // Scale and fade out content
            tl.to(modalContent, {
                scale: 0.9,
                opacity: 0,
                duration: 0.3,
                ease: 'power2.in',
            });

            // Fade out backdrop
            tl.to(modal, {
                opacity: 0,
                duration: 0.3,
                ease: 'power2.in',
            }, '-=0.2');
        };

        // Event listeners
        heroButton.addEventListener('click', openModal);
        modalCloseButtons.forEach(btn => btn.addEventListener('click', closeModal));

        // Close when clicking backdrop (outside video)
        modalBackdrop.addEventListener('click', closeModal);

        // Prevent closing when clicking on the video content itself
        modalContent.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.style.visibility === 'visible') {
                closeModal();
            }
        });
    }
}







